import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Button,
  CircularProgress,
  Select,
  MenuItem,
  ListItemText,
} from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import "../css/EditAccountDialog.css";
import { FBO_CUSTOMER_ROLE } from "../../utils/constants";

const EditAccountDialog = ({
  open,
  selectedProfile,
  onClickSave,
  onClose,
  isLoading,
}) => {
  const [selectedAccountType, setSelectedAccountType] = useState(null);

  useEffect(() => {
    if (selectedProfile) {
      setSelectedAccountType(selectedProfile?.associations[0]?.role);
    }
  }, [selectedProfile]);

  const handleAccountTypeChange = (event) => {
    setSelectedAccountType(event.target.value);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "edit-account-dialog-container",
      }}
    >
      <DialogContent>
        <CloseOutlined
          className="edit-account-dialog-close"
          onClick={onClose}
        />
        <div className="edit-account-dialog-content">
          <div className="edit-account-dialog-title">Edit</div>
          <div className="edit-account-input-container">
            <label>First Name</label>
            <div className="edit-account-non-editable-field">
              {selectedProfile?.firstName}
            </div>
          </div>
          <div className="edit-account-input-container">
            <label>Last Name</label>
            <div className="edit-account-non-editable-field">
              {selectedProfile?.lastName}
            </div>
          </div>
          <div className="edit-account-input-container">
            <label>Email</label>
            <div className="edit-account-non-editable-field">
              {selectedProfile?.email}
            </div>
          </div>
          <div className="edit-account-input-container">
            <label>Account Type</label>
            <Select
              className="edit-account-select-container"
              value={selectedAccountType}
              onChange={handleAccountTypeChange}
              renderValue={(selected) =>
                FBO_CUSTOMER_ROLE.find((type) => type.value === selected)?.name
              }
            >
              {FBO_CUSTOMER_ROLE.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  <ListItemText primary={type.name} />
                </MenuItem>
              ))}
            </Select>
          </div>
          <Button
            variant="contained"
            onClick={!isLoading ? () => onClickSave(selectedAccountType) : null}
            endIcon={
              isLoading ? <CircularProgress size={30} color="inherit" /> : null
            }
          >
            Save
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditAccountDialog;
